module.exports = __webpack_public_path__ + "img/about.4f9a81ee.jpg";